import request from '@/utils/request'

export function getJssdk (data) {
  return request({
    url: 'wechat/jssdk',
    method: 'POST',
    params: data
  })
}
// 获取 微信网页登陆 授权url
export function getWeixinLoginUrl (data) {
  return request({
    url: 'wechat/getLoginUrl',
    method: 'get',
    params: data
  })
}
export function getWeixinUserToken (data) {
  return request({
    url: 'wechat/oauth',
    method: 'POST',
    params: data
  })
}
